var CoinFeedbackSubmissionStatus;
(function (CoinFeedbackSubmissionStatus) {
    CoinFeedbackSubmissionStatus["All"] = "all";
    CoinFeedbackSubmissionStatus["Approved"] = "approved";
    CoinFeedbackSubmissionStatus["Deleted"] = "deleted";
    CoinFeedbackSubmissionStatus["Disapproved"] = "disapproved";
    CoinFeedbackSubmissionStatus["Flagged"] = "flagged";
    CoinFeedbackSubmissionStatus["Incomplete"] = "incomplete";
    CoinFeedbackSubmissionStatus["Submitted"] = "submitted";
})(CoinFeedbackSubmissionStatus || (CoinFeedbackSubmissionStatus = {}));
export default CoinFeedbackSubmissionStatus;
//# sourceMappingURL=CoinFeedbackSubmissionStatus.js.map